export function fromNow(date) {
	return moment(date).fromNow();
}


/** WEBPACK FOOTER **
 ** ./src/filters/datetime.js
 **/